export enum ELocalStorageKeys {
	accessToken = 'vemo-access-token',
	refreshToken = 'vemo-refresh-token',
	/** Last logged-in email; survives signout so error captures still show who it was. */
	lastUserEmail = 'vemo-last-user-email',
	country = 'vemo-country',
	hudId = 'vemo-hud-id',
	routeBeforeToGoToSigning = 'vemo-route-before-to-go-to-signing',
	isAdministrator = 'vemo-is-administrator',
	companies = 'vemo-companies',
	/** Last hub (location id) picked in the Checkin Conductor / Checkin Vehículo flows. */
	checkinHub = 'vemo-checkin-hub',
	/** Checkin flow chosen in the sidenav ('new' | 'legacy'); kept across reloads and tabs. */
	checkinFlow = 'vemo-checkin-flow',
}
